/* APP STORE - DATA KEYS */
export const LOADING = 'isLoading';
export const SONGS = 'songs';
export const RECORDS = 'records';
